import React from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Admin from './admin'
import Adminlogin from './admin/AdminLogin'
import AdminAddBrand from './admin/AdminAddBrand'
import AdminAddCatalog from './admin/AdminAddCatalog'
import AdminAddDocument from './admin/AdminAddDocument'
import AdminAddPoint from './admin/AdminAddPoint'
import AdminAddPrivilege from './admin/AdminAddPrivilege'
import AdminAddProduct from './admin/AdminAddProduct'
import AdminAddPromotion from './admin/AdminAddPromotion'
import AdminAddSpare from './admin/AdminAddSpare'
import AdminAddSpareBrand from './admin/AdminAddSpareBrand'
import AdminAddUser from './admin/AdminAddUser'
import AdminCatalog from './admin/AdminCatalog'
import AdminDelPoint from './admin/AdminDelPoint'
import AdminDocument from './admin/AdminDocument'
import AdminDocumentDetail from './admin/AdminDocumentDetail'
import AdminEditBrand from './admin/AdminEditBrand'
import AdminEditDocument from './admin/AdminEditDocument'
import AdminEditPrivilege from './admin/AdminEditPrivilege'
import AdminEditProduct from './admin/AdminEditProduct'
import AdminEditPromotion from './admin/AdminEditPromotion'
import AdminEditSpare from './admin/AdminEditSpare'
import AdminEditSpareBrand from './admin/AdminEditSpareBrand'
import AdminEditUser from './admin/AdminEditUser'
import AdminPoint from './admin/AdminPoint'
import AdminProduct from './admin/AdminProduct'
import AdminPrivilege from './admin/AdminPrivilege'
import AdminProductDetail from './admin/AdminProductDetail'
import AdminProductInventory from './admin/AdminProductInventory'
import AdminProductPromotion from './admin/AdminProductPromotion'
import AdminPromotion from './admin/AdminPromotion'
import AdminSpare from './admin/AdminSpare'
import AdminSpareDetail from './admin/AdminSpareDetail'
import Upload from './admin/upload'

import Downloadbrand from './components/Downloadbrand'
import Downloaddetail from './components/Downloaddetail'
import Login from './components/Login'
import LoginverifyFb from './components/LoginverifyFb';
import LoginverifyLine from './components/LoginverifyLine'
import Partsbrand from './components/Partsbrand'
import Partsdetail from './components/Partsdetail'
import Partstype from './components/Partstype'
import Pointdetail from './components/Pointdetail'
import Productbrand from './components/Productbrand'
import Productdetail from './components/Productdetail'
import Producttype from './components/Producttype'
import Profile from './components/Profile'
import Promotion from './components/Promotion'
import Promotiondetail from './components/Promotiondetail'

const Routes = () => (
    <Router>
        <div>
          <Switch>
            <Route exact path="/" component={Profile} />
            <Route path="/downloadbrand" component={Downloadbrand} />
            <Route path="/downloaddetail" component={Downloaddetail} />
            <Route path="/login" component={Login} />
            <Route path="/loginverifyfb" component={LoginverifyFb} />
            <Route path="/loginverifyline" component={LoginverifyLine} />
            <Route path="/partsbrand" component={Partsbrand} />
            <Route path="/partsdetail" component={Partsdetail} />
            <Route path="/partstype" component={Partstype} />
            <Route path="/pointdetail" component={Pointdetail} />
            <Route path="/productbrand" component={Productbrand} />
            <Route path="/productdetail" component={Productdetail} />
            <Route path="/producttype" component={Producttype} />
            <Route path="/profile" component={Profile} />
            <Route path="/promotion" component={Promotion} />
            <Route path="/promotiondetail" component={Promotiondetail} />

            <Route exact path="/admin" component={Admin} />
            <Route path="/admin/login" component={Adminlogin} /> 

            <Route path="/admin/addbrand" component={AdminAddBrand} />
            <Route path="/admin/addcatalog" component={AdminAddCatalog} />
            <Route path="/admin/adddocument" component={AdminAddDocument} />
            <Route path="/admin/addpoint" component={AdminAddPoint} />
            <Route path="/admin/addprivilege" component={AdminAddPrivilege} />
            <Route path="/admin/addproduct" component={AdminAddProduct} />
            <Route path="/admin/addpromotion" component={AdminAddPromotion} />
            <Route path="/admin/addspare" component={AdminAddSpare} />
            <Route path="/admin/addsparebrand" component={AdminAddSpareBrand} />
            <Route path="/admin/adduser" component={AdminAddUser} />
            <Route path="/admin/catalog" component={AdminCatalog} />
            <Route path="/admin/delpoint" component={AdminDelPoint} />
            <Route path="/admin/document" component={AdminDocument} />
            <Route path="/admin/documentdetail" component={AdminDocumentDetail} />
            <Route path="/admin/editbrand" component={AdminEditBrand} />
            <Route path="/admin/editdocument" component={AdminEditDocument} />
            <Route path="/admin/editprivilege" component={AdminEditPrivilege} />
            <Route path="/admin/editproduct" component={AdminEditProduct} />
            <Route path="/admin/editpromotion" component={AdminEditPromotion} />
            <Route path="/admin/editspare" component={AdminEditSpare} />
            <Route path="/admin/editsparebrand" component={AdminEditSpareBrand} />
            <Route path="/admin/edituser" component={AdminEditUser} />
            <Route path="/admin/point" component={AdminPoint} />
            <Route path="/admin/privilege" component={AdminPrivilege} />
            <Route path="/admin/product" component={AdminProduct} />
            <Route path="/admin/product-inventory" component={AdminProductInventory} />
            <Route path="/admin/productdetail" component={AdminProductDetail} />
            <Route path="/admin/productpromo" component={AdminProductPromotion} />
            <Route path="/admin/promotion" component={AdminPromotion} />
            <Route path="/admin/spare" component={AdminSpare} />
            <Route path="/admin/sparedetail" component={AdminSpareDetail} />
            <Route path="/upload" component={Upload} /> 

            <Route component={Profile} />
          </Switch>
        </div>
    </Router>
);

export default Routes;